/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Yup from 'yup'

import { REFUND_PAYMENT_MODES } from '../../../constants/models'

const validateField = (value: any, testContext: any) => {
  if (testContext.parent.paymentMode === REFUND_PAYMENT_MODES.BANK.key)
    if (value !== undefined && value !== null) {
      return value && value.toString().trim().length > 0
    } else return false

  return true
}
const Schema = Yup.object().shape({
  paymentMode: Yup.mixed()
    .required('Payment mode is required')
    .oneOf(Object.keys(REFUND_PAYMENT_MODES)),
  amountPaid: Yup.number().min(700).max(25000),
  bankName: Yup.string()
    .test('required-by-bank', 'Bank name is required', validateField)
    .test('validate', 'Bank name must not exceed 255 characters', (value) => {
      if (value !== undefined && value !== null)
        return /^[a-z ,.'-]{1,255}$/i.test(value.toString())
      return true
    }),
  accountName: Yup.string()
    .test('required-by-bank', 'Account name is required', validateField)
    .test(
      'validate',
      'Account name must not exceed 255 characters',
      (value) => {
        if (value !== undefined && value !== null)
          return /^[a-z ,.'-]{1,255}$/i.test(value.toString())
        return true
      },
    ),
  accountNumber: Yup.string().test({
    name: 'validate-field',
    test: (value: any, testContext: any) => {
      if ((value || '').toString().trim().length === 0) {
        return testContext.createError({
          message: `${
            testContext.parent.paymentMode === REFUND_PAYMENT_MODES.BANK.key
              ? 'Account'
              : 'GCash'
          } number is required`,
        })
      }

      if (value !== undefined && value !== null) {
        if (!/^[a-z0-9 ,.'-]{1,25}$/i.test(value.toString())) {
          return testContext.createError({
            message: `${
              testContext.parent.paymentMode === REFUND_PAYMENT_MODES.BANK.key
                ? 'Account'
                : 'GCash'
            } number must not exceed 25 characters`,
          })
        }
      }
      return true
    },
  }),
})

export default Schema
